import { minutesToSeconds } from "date-fns";

export const getMinutesAndSeconds = (totalMinutes: number): { minutes: number; seconds: number } => {
	const totalSeconds = minutesToSeconds(totalMinutes);
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = Math.floor(totalSeconds % 60);
	return { minutes, seconds };
};
